import { render, staticRenderFns } from "./SavedVehicleMetadata.vue?vue&type=template&id=3c9fbaa4"
import script from "./SavedVehicleMetadata.vue?vue&type=script&lang=ts"
export * from "./SavedVehicleMetadata.vue?vue&type=script&lang=ts"
import style0 from "./SavedVehicleMetadata.vue?vue&type=style&index=0&id=3c9fbaa4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports